import { useEnvironmentInterface } from "environment-interface";

import { LEGACY_AUTO_LAUNCH_VSCODE_KEY } from "utils/vscode";

import { useGlobalPersistedState } from "./usePersistedState";

export const useAutoLaunchVSCode = (): [
  boolean,
  React.Dispatch<React.SetStateAction<boolean>>,
] => {
  const { storage } = useEnvironmentInterface();
  const legacyFlag = storage.get<boolean>(LEGACY_AUTO_LAUNCH_VSCODE_KEY);

  const [autoOpenVSCode, setAutoOpenVSCode] = useGlobalPersistedState<boolean>(
    "AUTO_LAUNCH_VSCODE",
    !!legacyFlag,
  );

  // Getting rid of legacy flag
  if (legacyFlag !== null) {
    storage.delete(LEGACY_AUTO_LAUNCH_VSCODE_KEY);
    setAutoOpenVSCode(legacyFlag);
  }

  return [autoOpenVSCode, setAutoOpenVSCode];
};
